var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, Fragment, useMemo } from 'react';
import { PageTitle } from '@src/_metronic/layout/core';
import { KTCard } from '@src/_metronic/helpers';
import { FormatYearMonthDateHypen } from '@src/app/helper';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useReport } from './Report.requests';
import dayjs from 'dayjs';
import SelectFormik from '@src/components/Atoms/Formik/Select/SelectFormik';
import MultiSelectFormik from '@src/components/Atoms/Formik/MultiSelect/MultiSelectFormik';
import Date from '@src/components/Atoms/Date/Date';
import '@src/app/styles/style.css';
import { useTenants } from '../../TenantPage/TenantHooks/Tenant.hooks';
var usersBreadcrumbs = [
    {
        title: 'Report',
        path: '/',
        isSeparator: true,
        isActive: false,
    },
];
var reportTypeOptions = [
    { name: 'Good Receipt', value: 'good_receipt' },
    { name: 'Treasury', value: 'treasury' },
    { name: 'Summary', value: 'summary' },
];
var reportTypeLabels = {
    good_receipt: 'Good_Receipt',
    treasury: 'Treasury',
    summary: 'Summary',
};
var ReportFormSchema = Yup.object().shape({
    reportType: Yup.string().required('Tipe laporan harus dipilih'),
    tenantIds: Yup.array().min(1, 'Minimal 1 perusahaan harus dipilih').required('Perusahaan harus dipilih'),
});
var todayDate = dayjs().format('YYYY-MM-DD').toString();
var ReportIndex = function () {
    var _a = useReport(), downloadGoodReceipt = _a.downloadGoodReceipt, downloadTreasury = _a.downloadTreasury, downloadSummary = _a.downloadSummary;
    var tenants = useTenants().tenants;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(todayDate), startDate = _c[0], setStartDate = _c[1];
    var _d = useState(todayDate), endDate = _d[0], setEndDate = _d[1];
    var _e = useState([]), selectedTenants = _e[0], setSelectedTenants = _e[1];
    var tenantOptions = useMemo(function () {
        if (!tenants || tenants.length === 0)
            return [];
        return tenants
            .filter(function (tenant) { return tenant.name.toLowerCase() !== 'nexgen'; })
            .map(function (tenant) { return ({
            value: tenant.pubId,
            label: tenant.name,
        }); });
    }, [tenants]);
    var ReportFormik = useFormik({
        initialValues: {
            reportType: '',
            tenantIds: [],
        },
        enableReinitialize: true,
        validationSchema: ReportFormSchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var tenantIds, payload, file, _a, FILE_API_BASE_URL, url, fileName, response, blob, downloadUrl, link, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        tenantIds = values.tenantIds.map(function (t) { return t.value; });
                        payload = {
                            startDate: startDate.toString(),
                            endDate: endDate.toString(),
                            dateBy: '',
                            tenantIds: tenantIds,
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 12, , 13]);
                        file = void 0;
                        _a = values.reportType;
                        switch (_a) {
                            case 'good_receipt': return [3 /*break*/, 2];
                            case 'treasury': return [3 /*break*/, 4];
                            case 'summary': return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 8];
                    case 2:
                        payload.dateBy = 'PostedDate';
                        return [4 /*yield*/, downloadGoodReceipt(payload)];
                    case 3:
                        file = _b.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        payload.dateBy = 'PaymentDue';
                        return [4 /*yield*/, downloadTreasury(payload)];
                    case 5:
                        file = _b.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        payload.dateBy = 'ApprovedDate';
                        return [4 /*yield*/, downloadSummary(payload)];
                    case 7:
                        file = _b.sent();
                        return [3 /*break*/, 8];
                    case 8:
                        if (!file) return [3 /*break*/, 11];
                        FILE_API_BASE_URL = process.env.NEXUS_FILE_API_URL;
                        url = "".concat(FILE_API_BASE_URL, "/").concat(file.pubId, "/download");
                        fileName = "".concat(reportTypeLabels[values.reportType], "_").concat(startDate, "_-_").concat(endDate, ".xlsx");
                        return [4 /*yield*/, fetch(url)];
                    case 9:
                        response = _b.sent();
                        return [4 /*yield*/, response.blob()];
                    case 10:
                        blob = _b.sent();
                        downloadUrl = window.URL.createObjectURL(blob);
                        link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(downloadUrl);
                        _b.label = 11;
                    case 11:
                        setLoading(false);
                        return [3 /*break*/, 13];
                    case 12:
                        e_1 = _b.sent();
                        setLoading(false);
                        return [3 /*break*/, 13];
                    case 13: return [2 /*return*/];
                }
            });
        }); },
    });
    var onChangeStartDate = function (e) {
        var event = { target: { name: '', value: null } };
        event.target.name = 'startDate';
        event.target.value = e == null ? '' : FormatYearMonthDateHypen(e);
        setStartDate(event.target.value);
        ReportFormik.setFieldValue(event.target.name, event.target.value);
    };
    var onChangeEndDate = function (e) {
        var event = { target: { name: '', value: null } };
        event.target.name = 'endDate';
        event.target.value = e == null ? '' : FormatYearMonthDateHypen(e);
        setEndDate(event.target.value);
        ReportFormik.setFieldValue(event.target.name, event.target.value);
    };
    var onChangeTenants = function (selected) {
        setSelectedTenants(selected || []);
        ReportFormik.setFieldValue('tenantIds', selected || []);
    };
    return (_jsxs(Fragment, { children: [_jsx(PageTitle, __assign({ breadcrumbs: usersBreadcrumbs }, { children: "Report" })), _jsx(KTCard, { children: _jsx("div", __assign({ className: 'row g-5' }, { children: _jsx("div", __assign({ className: 'col-lg-6' }, { children: _jsx("div", __assign({ className: 'card card-flush shadow-sm' }, { children: _jsx("div", __assign({ className: 'card-body p-0' }, { children: _jsxs("form", __assign({ id: 'kt_report_form', className: 'form', noValidate: true, onSubmit: ReportFormik.handleSubmit }, { children: [_jsx("div", __assign({ className: 'mx-5 mx-xl-15 my-7' }, { children: _jsx(MultiSelectFormik, { label: 'Perusahaan', name: 'tenantIds', formik: ReportFormik, options: tenantOptions, isMulti: true, value: selectedTenants, onchange: onChangeTenants, isRequired: true, clearable: true }) })), _jsx("div", __assign({ className: 'mx-5 mx-xl-15 my-7' }, { children: _jsx(SelectFormik, { label: 'Tipe', name: 'reportType', formik: ReportFormik, optionList: reportTypeOptions, isRequired: true }) })), _jsxs("div", __assign({ className: 'mx-5 mx-xl-15 my-7' }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder text-dark required' }, { children: "Tanggal Mulai" })), _jsx(Date, { date: startDate, handleonchange: onChangeStartDate })] })), _jsxs("div", __assign({ className: 'mx-5 mx-xl-15 my-7' }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder text-dark required' }, { children: "Tanggal Hingga" })), _jsx(Date, { date: endDate, handleonchange: onChangeEndDate })] })), _jsx("div", __assign({ className: 'button-container' }, { children: _jsxs("button", __assign({ type: 'submit', id: 'kt_report_submit', className: 'btn btn-primary', disabled: ReportFormik.isSubmitting || !ReportFormik.isValid }, { children: [!loading && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Download" })), loading && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] })) }))] })) })) })) })) })) })] }));
};
export default ReportIndex;
